export class PluralHelper {
	getOrderText(data: { order: number }): string {
		const orderString = data.order.toString();
		const lastOrderNumber = orderString[orderString.length - 1];
		if (lastOrderNumber === '0') {
			return '0';
		}
		if (lastOrderNumber === '1') {
			return `${data.order}st`;
		}
		if (lastOrderNumber === '2') {
			return `${data.order}nd`;
		}
		if (lastOrderNumber === '3') {
			return `${data.order}rd`;
		}
		return `${data.order}th`;
	}

	getPluralText(data: { count: number; m0: string; m1: string; m5: string }): string {
		if (data.count === 0) {
			return data.m0;
		}
		if (data.count === 1) {
			return data.m1;
		}

		return data.m5;
	}
}

export const pluralHelper = new PluralHelper();
